module.exports = __webpack_public_path__ + "img/智慧工业园区.45d7a1d8.png";